export const coreAddresses = {
  balanceTracker: "0x0D52d06ceB8Dcdeeb40Cfd9f17489B350dD7F8a3",
  eVaultFactory: "0x29a56a1b8214D9Cf7c5561811750D5cBDb45CC8e",
  eVaultImplementation: "0x8Ff1C814719096b61aBf00Bb46EAd0c9A529Dd7D",
  eulerEarnFactory: "0x59709B029B140C853FE28d277f83C3a65e308aF4",
  evc: "0x0C9a3dd6b8F28529d72d7f9cE918D493519EE383",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x4cD6BF1D183264c02Be7748Cb5cd3A47d013351b",
  sequenceRegistry: "0xEADDD21618ad5Deb412D3fD23580FD461c106B54",
} as const
